module.exports = __webpack_public_path__ + "static/media/Alexandra Kline Headshot.e65cb7d3.jpg";